<template>
    <div class="container">
        <div class="page-content mt-10">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        Poké Fishing
                    </h1>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-6">
                            Score: {{ score }}<br/>
                            Fishies caught: {{ fishiesCaught.length }}
                        </div>
                        <div class="col-6">
                            Force: {{ force }}<br/>
                            Pulling: {{ pull }}<br/>
                        </div>
                        <div class="col-12">
                            <div class="rod">
                                <p class="hook" :style="'margin-bottom: ' + force * 2 + 'px'"></p>
                                <div v-if="fishy" class="fish" :style="'bottom: '+fishy.position+'px'">
                                    <img :src="fishy.sprite" alt="fishy.sprite"><br/>
                                    <div class="fishyScoreIndicatorWrapper">
                                        <div class="fishyScoreIndicator" :style="'width: '+(fishyScore)+'%;'"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-2">
                            <a class="btn btn-success w-100 pull-button" v-on:pointerdown="pull = true" v-on:pointerup="pull = false">
                                PULL
                            </a>
                        </div>
                        <div class="col-12">
                            <a href="javascript:" class="btn btn-danger w-100" v-on:click="deployFish()" v-if="!fishy">LET THERE BE FISH</a>
                        </div>
                    </div>
                </div>
                <template v-if="fishy">
                    Fishy-position: {{ fishyPosition }}<br/>
                    Fishy-name: {{ fishy.name }}<br/>
                    FishyScore: {{ fishyScore }}<br/>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Fishy",
    data() {
        return {
            score: 0,
            force: 0,
            pull: false,
            pullRate: 2.5,
            dropRate: 3.5,
            percentPerMatchingTick: 2,
            intervals: {
                forceIntervalID: null,
                fishMovementIntervalID: null
            },
            fishy: null,
            fishiesCaught: [],
            fishies: [
                {
                    name: 'Luvdisc',
                    strength: 3,
                    quirkyness: 5,
                    points: 100,
                    position: 0,
                    sprite: 'https://archives.bulbagarden.net/media/upload/b/b4/Ani370MS.png'
                },
                {
                    name: 'Magikarp',
                    strength: 3,
                    quirkyness: 2,
                    points: 50,
                    position: 200,
                    sprite: 'https://archives.bulbagarden.net/media/upload/e/ef/Ani129OD.png'
                },
                {
                    name: 'Gyarados',
                    strength: 3,
                    quirkyness: 10,
                    points: 50,
                    position: 200,
                    sprite: 'https://archives.bulbagarden.net/media/upload/d/d1/Ani130MS.png'
                }
            ],
            fishyScore: 0
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
    },
    computed: {
        fishyPosition() {
            return this.fishy ? (this.fishy.position / 2) : -200;
        },
        fishyInRange() {
            return (this.force < (this.fishyPosition + 10) && this.force > (this.fishyPosition -10));
        }
    },
    watch: {
        pull() {
            let vue = this;
            window.clearInterval(vue.intervals.forceIntervalID);

            if (vue.pull) {
                vue.intervals.forceIntervalID = setInterval(function () {
                    if (vue.force < 125) {
                        vue.force = Number(vue.force) + vue.pullRate;
                    }
                }, 50);
            } else {
                vue.intervals.forceIntervalID = setInterval(function () {
                    if (vue.force >= 0.0) {
                        vue.force = Number(vue.force) - vue.dropRate;
                    }

                    if (vue.force < 0.7) {
                        vue.force = 0;
                    }
                }, 50);
            }
        }
    },
    methods: {
        pullRod() {
            this.force = Number(this.force) + 0.5;
        },
        deployFish() {
            this.fishy = this.fishies.random();
            this.fishyScore = 20;
            this.startFishLifecycle();
        },
        startFishLifecycle() {
            let vue = this;
            this.fishy.position = 0;

            this.intervals.fishMovementIntervalID = setInterval(() => {
                let up = Math.floor(Math.random() * 101) <= 55;

                if (up) {
                    if (vue.fishy.position < 250) {
                        vue.fishy.position += vue.fishy.quirkyness;
                    } else {
                        vue.fishy.position -= vue.fishy.quirkyness;
                    }
                } else {
                    if (vue.fishy.position >= vue.fishy.quirkyness) {
                        vue.fishy.position = Number(vue.fishy.position) - vue.fishy.quirkyness;
                    }
                }

                if (vue.fishyScore >= 100) {
                    vue.fishyCaught();
                } else if (vue.fishyInRange) {
                    vue.fishyScore += this.percentPerMatchingTick;
                } else {
                    if (vue.fishyScore > 0) {
                        vue.fishyScore -= this.percentPerMatchingTick;
                    } else {
                        vue.fishyFled();
                    }
                }
            }, 100);
        },
        fishyCaught() {
            window.clearInterval(this.intervals.fishMovementIntervalID);

            this.score += this.fishy.points;
            this.fishiesCaught.push(this.fishy);

            this.fishy = null;
            this.pull = false;

            iziToast.success({
                title: 'fischi ist jetzt dein freund',
                position: 'bottomCenter'
            });
        },
        fishyFled() {
            window.clearInterval(this.intervals.fishMovementIntervalID);

            this.fishy = null;
            this.pull = false;

            iziToast.warning({
                title: 'fischi fort!',
                position: 'bottomCenter'
            });
        }
    },
};
</script>


<style scoped lang="scss">
.pull-button {
    font-size: 2.5em;
    padding: 2em 2em;
}

.rod {
    width: 50px;
    height: 300px;
    //border: 1px solid black;
    //background-color: lightblue;
    background-image: url('https://i.pinimg.com/736x/03/e0/a9/03e0a90075b75f2abed73aeb2693fe37.jpg') ;
    padding: 0;
    border: 3px solid white;
    border-radius: 5px;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2em;
    margin-bottom: 2em;
}

.hook {
    background-color: sandybrown;
    width: 100%;
    height: 50px;
    margin: 0;
}

.pull {
    background-color: cornflowerblue;
    height: 100px;
    border-radius: 15px;
    border: 5px solid darkblue;

    display: flex;
    align-content: space-around;
    justify-content: space-around;
    align-items: center;

    color: white;
}

* {
    user-select: none;
}

.pull:active {
    background-color: #a4bbe5;
    margin-top: 3px;
}

.fish {
    width: 50px;
    position: absolute;
    z-index: 10;
}

.fish img {
    width: 100%;
    height: 64px;
}

.fishyScoreIndicatorWrapper {
    height: 10px;
    margin-top: -15px;
    width: 100%;
    background-color: white;
    z-index: 50;
}

.fishyScoreIndicator {
    height: 10px;
    width: 0%;
    margin: 0;
    padding: 0;
    background-color: greenyellow;
    z-index: 50;
}
</style>
